// console.log("process.env.REACT_APP_BASE_URL",process.env.REACT_APP_BASE_URL)

const RUNTIME = window.__RUNTIME_CONFIG__ || window._env_ || {};

console.log("RUNTIME CONFIG:", RUNTIME);



const dev = {

  

  // API_AGENT: "https://vlmai.voicera-analytics.com",

  // BASE_URL: "http://localhost:8002",

  // BASE_URL:  "https://vlmai.voicera-analytics.com",

  // 

  // BASE_URL:  "http://localhost:8002",
  BASE_URL: RUNTIME.BASE_URL || process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8005",
  WEB_CRAWLER_BASE_URL: RUNTIME.WEB_CRAWLER_BASE_URL || "https://document-microservice.voiceracx.ai",
  // API_AGENT: RUNTIME.API_AGENT || "https://vlmai.voicera-analytics.com",

  // BASE_URL: "https://b4f61cb56c29.ngrok-free.app",

  // BASE_URL: "https://regularly-handles-container-living.trycloudflare.com",

  // API_WEBSOCKET: "wss://47.85.41.83:8000",

  API_WEBSOCKET: "wss://vlmliteapi-staging.voiceracx.ai",

  IFRAME_CHAT_URL: "https://chat-microservice.staging.voiceracx.ai",

  IFRAME_WEBSOCKET_URL: "https://chat-microservice.staging.voiceracx.ai",

  VIDEO_APP_URL: "https://video-in-flex-functions-2927-dev.twil.io",

  // Testing Framework Backend (separate from main backend)

  TESTING_API_BASE_URL: "https://vlm-shield.voiceracx.ai/api",

  // External Service URLs

  PUBLIC_URL: RUNTIME.PUBLIC_URL || "http://localhost:3000",

  FRONTEND_URL: RUNTIME.FRONTEND_URL || "http://localhost:3000",

  VLM_UI_URL: RUNTIME.VLM_UI_URL || "http://localhost:3000",

  SCHEDULER_URL:"https://vdlappqa-cxg2aqf5abgscvcx.eastus-01.azurewebsites.net/auth/login?redirect=/campaigns/campaign",

  // SCHEDULER_URL: "http://localhost:3001",

  FB_APP_ID: RUNTIME.FB_APP_ID || "1480461767112892",

  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",

  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",

  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",

  LINKEDIN_CLIENT_ID: RUNTIME.LINKEDIN_CLIENT_ID || process.env.REACT_APP_LINKEDIN_CLIENT_ID || "",

  LINKEDIN_REDIRECT_URI: RUNTIME.LINKEDIN_REDIRECT_URI || process.env.REACT_APP_LINKEDIN_REDIRECT_URI || "",

  App_URL: RUNTIME.App_URL || "https://vlmlite.staging.voiceracx.ai",

  // Audio S3 Configuration

  AUDIO_S3_BUCKET: RUNTIME.AUDIO_S3_BUCKET || process.env.REACT_APP_AUDIO_S3_BUCKET || "vlmtestdata",

  AUDIO_S3_REGION: RUNTIME.AUDIO_S3_REGION || process.env.REACT_APP_AUDIO_S3_REGION || "us-east-1",

  AUDIO_S3_BASE_URL: RUNTIME.AUDIO_S3_BASE_URL || process.env.REACT_APP_AUDIO_S3_BASE_URL || "https://vlmtestdata.s3.us-east-1.amazonaws.com",

  AUDIO_S3_PATH: RUNTIME.AUDIO_S3_PATH || process.env.REACT_APP_AUDIO_S3_PATH || "Botnoi+Voices/A_Records",

};



const prod = {

  BASE_URL: RUNTIME.BASE_URL || process.env.REACT_APP_BASE_URL || "https://vlmliteapi-staging.voiceracx.ai",
  WEB_CRAWLER_BASE_URL: RUNTIME.WEB_CRAWLER_BASE_URL || "https://document-microservice.voiceracx.ai",

  API_AGENT: RUNTIME.API_AGENT || process.env.REACT_APP_API_AGENT || "https://vlmliteapi-staging.voiceracx.ai",

  API_WEBSOCKET: RUNTIME.API_WEBSOCKET || process.env.REACT_APP_API_WEBSOCKET || "wss://vlmliteapi-staging.voiceracx.ai",

  // Testing Framework Backend (separate from main backend)

  TESTING_API_BASE_URL: "https://vlm-shield.voiceracx.ai/api",



  PUBLIC_URL: RUNTIME.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL || "https://vlmlite.staging.voiceracx.ai",

  FRONTEND_URL: RUNTIME.FRONTEND_URL || "https://vlmlite.staging.voiceracx.ai",

  VLM_UI_URL: RUNTIME.VLM_UI_URL || "https://vlmlite.staging.voiceracx.ai",

  AUTH_URL: RUNTIME.AUTH_URL || "https://vlmlite.staging.voiceracx.ai",

  LOGIN_URL: RUNTIME.LOGIN_URL || "https://vlmlite.staging.voiceracx.ai/auth/login",



  SCHEDULER_URL:"https://vdlappqa-cxg2aqf5abgscvcx.eastus-01.azurewebsites.net/auth/login?redirect=/campaigns/campaign",

  App_URL: RUNTIME.App_URL || "https://vlmlite.staging.voiceracx.ai",

  FB_APP_ID: RUNTIME.FB_APP_ID || "1480461767112892",

  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",

  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",

  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",

  LINKEDIN_CLIENT_ID: RUNTIME.LINKEDIN_CLIENT_ID || process.env.REACT_APP_LINKEDIN_CLIENT_ID || "",

  LINKEDIN_REDIRECT_URI: RUNTIME.LINKEDIN_REDIRECT_URI || process.env.REACT_APP_LINKEDIN_REDIRECT_URI || "",

  // Video App URL - can be different from BASE_URL

  VIDEO_APP_URL: "https://video-in-flex-functions-2927-dev.twil.io",

  // Chat microservice (used by in-app "Chat with Agent" and iframe widget)

  IFRAME_CHAT_URL: RUNTIME.IFRAME_CHAT_URL || "https://chat-microservice.staging.voiceracx.ai",

  IFRAME_WEBSOCKET_URL: RUNTIME.IFRAME_WEBSOCKET_URL || "https://chat-microservice.staging.voiceracx.ai",

  // Audio S3 Configuration

  AUDIO_S3_BUCKET: RUNTIME.AUDIO_S3_BUCKET || process.env.REACT_APP_AUDIO_S3_BUCKET || "vlmtestdata",

  AUDIO_S3_REGION: RUNTIME.AUDIO_S3_REGION || process.env.REACT_APP_AUDIO_S3_REGION || "us-east-1",

  AUDIO_S3_BASE_URL: RUNTIME.AUDIO_S3_BASE_URL || process.env.REACT_APP_AUDIO_S3_BASE_URL || "https://vlmtestdata.s3.us-east-1.amazonaws.com",

  AUDIO_S3_PATH: RUNTIME.AUDIO_S3_PATH || process.env.REACT_APP_AUDIO_S3_PATH || "Botnoi+Voices/A_Records",

};



const test = {

  API_ENDPOINT_URL: "/api",



  // Authentication URLs for testing

  AUTH_URL: "https://5540-103-182-158-109.ngrok-free.app",

  LOGIN_URL: "https://5540-103-182-158-109.ngrok-free.app/auth/login",



  // External Service URLs for testing

  SCHEDULER_URL: "http://localhost:3001/scheduler", // Different port for testing

  FB_APP_ID: RUNTIME.FB_APP_ID || process.env.REACT_APP_FB_APP_ID || "YOUR_FB_APP_ID_HERE",

  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",

  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",

  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",

  LINKEDIN_CLIENT_ID: RUNTIME.LINKEDIN_CLIENT_ID || process.env.REACT_APP_LINKEDIN_CLIENT_ID || "",

  LINKEDIN_REDIRECT_URI: RUNTIME.LINKEDIN_REDIRECT_URI || process.env.REACT_APP_LINKEDIN_REDIRECT_URI || "",

};



const getEnv = () => {

  switch (process.env.NODE_ENV) {

    case "development":

      return dev;

    case "production":

      return prod;

    case "test":

      return test;

    default:

      break;

  }

};



export const env = getEnv();

